// Libs
import classNames from 'classnames/bind';
import { Box, Chip } from '@mui/material';
// Components, Layouts, Pages
// Others
import { formatTitleCase } from '~/utils/helper/common';
import { ChipColorEnum, StatusEnum } from '~/utils/enum/common';
import { TStatusType } from '~/utils/type/common';
// Styles, images, icons
import styles from './BaseStatus.module.scss';

type Props = {
  label: string;
  type?: TStatusType;
  isDot?: boolean;
};

const cx = classNames.bind(styles);

const BaseStatus = (props: Props) => {
  //#region Destructuring Props
  const { label, type = 'small', isDot = false } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const getColor = () => {
    switch (label) {
      case StatusEnum.HIGH:
      case StatusEnum.HIGH_CASE:
      case StatusEnum.HIGH_LOWER:
      case StatusEnum.PENDING:
      case StatusEnum.INACTIVE:
      case StatusEnum.QUOTE_CANCELLED:
      case StatusEnum.UNAVAILABLE:
      case StatusEnum.DAMAGED:
      case StatusEnum.PO_CANCEL:
      case StatusEnum.PO_CLOSED:
      case StatusEnum.OVERBOOKING:
      case StatusEnum.CANCELED:
      case StatusEnum.UNASSIGNED:
        return ChipColorEnum.ERROR;
      case StatusEnum.LEAD:
      case StatusEnum.SCHEDULED:
      case StatusEnum.SCHEDULED_LOWER:
      case StatusEnum.OVERDUE:
      case StatusEnum.NOT_PAID:
      case StatusEnum.DELIVERY:
        return ChipColorEnum.SECONDARY;
      case StatusEnum.IN_PROCESS:
      case StatusEnum.MEDIUM:
      case StatusEnum.PENDING_LOWER:
      case StatusEnum.PO_OPEN:
      case StatusEnum.MAINTENANCE:
        return ChipColorEnum.WARNING;
      case StatusEnum.LOW:
      case StatusEnum.PARTIAL:
      case StatusEnum.CLIENT:
      case StatusEnum.PARTIALLY_PAID:
      case StatusEnum.IN_PROGRESS:
      case StatusEnum.PENDING_APPROVAL:
      case StatusEnum.INSTITUTIONAL:
      case StatusEnum.PO_PENDING_DELIVERY:
      case StatusEnum.PO_RECEIVED:
      case StatusEnum.PO_APPROVED:
      case StatusEnum.PICKUP:
        return ChipColorEnum.INFO;
      case StatusEnum.QUOTE_EXPIRED:
      case StatusEnum.ORDER_HOLD:
      case StatusEnum.DRAFT:
      case StatusEnum.ORDER:
      case StatusEnum.QUOTE:
        return ChipColorEnum.PRIMARY;
      case StatusEnum.COMPLETED:
      case StatusEnum.PAID:
        return ChipColorEnum.SUCCESS;
      default:
        return ChipColorEnum.DEFAULT;
    }
  };
  //#endregion Handle Function

  return (
    <Chip
      classes={{
        root: cx('chip', type),
        colorDefault: cx('backgroundDefault', isDot && 'isDot'),
        colorSuccess: cx('backgroundSuccess', isDot && 'isDot'),
        colorWarning: cx('backgroundWarning', isDot && 'isDot'),
        colorError: cx('backgroundError', isDot && 'isDot'),
        colorInfo: cx('backgroundInfo', isDot && 'isDot'),
        colorPrimary: cx('backgroundPrimary', isDot && 'isDot'),
        colorSecondary: cx('backgroundSecondary', isDot && 'isDot'),
        outlined: cx('outlined'),
      }}
      variant='outlined'
      color={getColor()}
      {...(isDot && { avatar: <Box className={cx('dot', getColor())} /> })}
      label={formatTitleCase(label)}
    />
  );
};

export default BaseStatus;
